import React from 'react';
import styled from 'styled-components';

interface Props {}

const Header = styled.div`
  font-size: 32px;
  font-weight: 300;
  margin-top: 32px;
  margin-bottom: 32px;
`;
const CardHeader: React.FunctionComponent<Props> = props => {
  return <Header>{props.children}</Header>;
};

export default CardHeader;
